import { cn } from "@app/lib/utils";
import { Link } from "@design-system/components";
import { trans } from "@mongez/localization";
import { ChevronRight } from "lucide-react";

export type BreadcrumbItem = {
  label: string;
  link?: string; // Optional - if no link, it's the current page
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
  classes?: {
    link?: string;
    span?: string;
  };
};

export function Breadcrumb({
  items,
  className = "",
  classes = {},
}: BreadcrumbProps) {
  return (
    <nav className={`flex items-center ${className}`}>
      <div className="flex items-center flex-wrap gap-2 text-sm text-white">
        {items.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            {item.link ? (
              <Link
                to={item.link}
                className={cn(
                  "cursor-pointer transition-colors hover:text-orange-400",
                  classes?.link,
                )}
              >
                {trans(item.label)}
              </Link>
            ) : (
              <span className={cn("text-white", classes?.span)}>
                {trans(item.label)}
              </span>
            )}

            {/* Show chevron if not the last item */}
            {index < items.length - 1 && (
              <ChevronRight size={14} className="rtl:rotate-180" />
            )}
          </div>
        ))}
      </div>
    </nav>
  );
}
